import { createStore } from 'vuex';

export default createStore({
  state: {
    cart: null,
    subjectId:null,
    title:null,
    currency: null,
  },
  mutations: {
    defineCart(state,data){
      //console.log("defineCart:",data);
      state.cart=data;
    },
    clearCart(state){
      state.cart=null;
    },
    defineTitle(state,data){
      //console.log("defineTitle:",data);
      state.title=data;
    },
    clearTitle(state){
      state.title=null;
    },
    defineSubjectId(state,data){
      //console.log("subjectId:",data);
      state.subjectId=data;
    },
    clearSubjectId(state){      
      //console.log("clear subjectId:"+state.subjectId);
      state.subjectId=null;      
    },
    defineCurrency(state,data){
      //console.log("currency:",data);
      state.currency=data;
    },
    clearCurrency(state){      
      //console.log("currency:"+state.currency);
      state.currency=null;      
    },
  },
  actions: {
    retrieveCart({commit,state}){
      //console.log("retrieveToken:{}",state.cart);
      if(state.cart === null || state.cart === "undefined"){
        if (typeof Storage !== "undefined") {
          let cart=sessionStorage.getItem("cart");        
          if(cart){        
            commit('defineCart',cart);   
          }
        }
      }
    },    
    createCart({commit},payload){ 
      //alert('createToken');           
      commit('defineCart',payload); 
    },
    removeCart(context){             
      context.commit('clearCart'); 
    },
    
    retrieveSubjectId({commit,state}){
      //console.log("retrieveSubjectId:{}",state.subjectId);
      if(state.subjectId === null || state.subjectId === "undefined"){
        if (typeof Storage !== "undefined") {
          let subjectId=sessionStorage.getItem("subjectId");        
          if(subjectId){        
            commit('defineSubjectId',subjectId);   
          }
        }
      }
      
    },    
    createSubjectId({commit},payload){
      commit('defineSubjectId',payload); 
    },
    removeSubjectId(context){             
      context.commit('clearSubjectId'); 
    },

    retrieveTitle({commit,state}){
      //console.log("retrieveTitle:{}",state.title);
      if(state.title === null || state.title === "undefined"){
        if (typeof Storage !== "undefined") {
          let title=sessionStorage.getItem("title");        
          if(!title||title.length==0){                    
            title=process.env.VUE_APP_TITLE.toUpperCase()
          }
          commit('defineTitle',title); 
        }
      }
      
    },    
    createTitle({commit},payload){
      commit('defineTitle',payload); 
    },
    removeTitle(context){             
      context.commit('clearTitle'); 
    },

    retrieveCurrency({commit,state}){
      //console.log("retrieveCurrency:{}",state.currency);
      if(state.currency === null || state.currency === "undefined"){
        if (typeof Storage !== "undefined") {
          let currency=sessionStorage.getItem("currency");        
          if(currency){        
            commit('defineCurrency',currency);   
          }
        }
      }      
    },    
    createCurrency({commit},payload){         
      commit('defineCurrency',payload); 
    },
    removeCurrency(context){             
      context.commit('clearCurrency'); 
    }
  },
  modules: {
  }
});
